const defaultBanner = '/images/parallax/FLXR-media.jpg';
import {useEffect} from "react";
import gsap from "gsap";

type Props = {
    overline?: string;
    title?: string;
    style?: 'white';
    height?: string;
    backgroundSize?: string;
    backgroundPosition?: string;
    children?: React.ReactNode;
    parallaxSpeed?: number;
    src?: string;
};
const HeroContent = ({
                         src = defaultBanner,
                         height = "450px",
                         backgroundSize,
                         backgroundPosition,
                         children
                     }: Props) => {


    useEffect(() => {
        const tl = gsap.timeline({repeat: -1, yoyo: true});

        tl.to(".move-background", {
            x: -40, // or x: 10 for sideways motion
            ease: "sine.inOut",
            duration: 5
        });
    }, []);

    // uses bg-fixed
    return (
        <div className="relative flex items-center justify-center" style={{height}}>
            <div className="absolute top-0 left-0 w-full h-full z-0 overflow-hidden">
                <div
                    className="w-[calc(100%+40px)] h-full bg-cover bg-center bg-scroll md:bg-fixed move-background"
                    style={{
                        backgroundImage: `url('${src}')`,
                        backgroundSize,
                        backgroundPosition,
                    }}
                />
            </div>
            <div className='z-1'>
                {children}
            </div>
        </div>
    )


};

export default HeroContent;
